<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <b-card>
        <form method="post" v-on:submit.prevent="e.preventDefault()">
          <div class="vx-row" :key="set.id" v-for="set in setting">
            <div class="vx-col w-full">
              <label
                >{{
                  $t(set.field_name.replace(/[\s\/]/g, "")) !==
                  set.field_name.replace(/[\s\/]/g, "")
                    ? $t(set.field_name.replace(/[\s\/]/g, ""))
                    : set.field_name
                }}
                <span class="red">*</span></label
              >
              <div v-if="set.type == 'textarea'">
                <b-form-textarea
                  id="textarea-large"
                  size="lg"
                  rows="3"
                  :type="set.type"
                  v-model="set.value"
                  :label="
                    $t(set.field_name.replace(/[\s\/]/g, '')) !==
                    set.field_name.replace(/[\s\/]/g, '')
                      ? $t(set.field_name.replace(/[\s\/]/g, ''))
                      : set.field_name
                  "
                  :placeholder="
                    $t(set.field_name.replace(/[\s\/]/g, '')) !==
                    set.field_name.replace(/[\s\/]/g, '')
                      ? $t(set.field_name.replace(/[\s\/]/g, ''))
                      : set.field_name
                  "
                  :name="set.slug"
                  :data-vv-as="$t(set.field_name.replace(/[\s\/]/g, ''))"
                  @keyup.enter.exact="submitForm"
                  v-validate="'required'"
                ></b-form-textarea>
              </div>

              <span class="text-danger text-sm" v-show="errors.has(set.slug)">{{
                errors.first(set.slug)
              }}</span>
            </div>

            <div class="vx-col w-full" v-if="set.type == 'radio'">
              <div class="flex walk-card">
                <b-form-checkbox    size="lg" v-model="set.value" name="check-button" switch>
                </b-form-checkbox>
                <!-- <vs-switch v-model="set.value" /> -->
                <label class="ml-2" for="">{{
                  $t(set.field_name.replace(/[\s\/]/g, ""))
                }}</label>
              </div>

              <span class="text-danger text-sm" v-show="errors.has(set.slug)">{{
                errors.first(set.slug)
              }}</span>
            </div>
          </div>

          <div class="vx-col" id="update">
            <b-button
              variant="primary"
              v-if="this.$route.params.id"
              type="filled"
              @click.prevent="updateForm"
              class="mt-5 br-20 pl-5 pr-5"
              >{{ $t("Update") }}</b-button
            >

            <b-button
              variant="primary"
              v-else
              type="filled"
              @click.prevent="submitForm"
              class="mt-5 br-20 pl-5 pr-5 border-primary"
              >{{ $t("Submit") }}</b-button
            >

            <router-link :to="'/admin/dashboard'">
              <b-button
                id="cancel"
                class="mt-5 br-20 pl-5 pr-5 border-primary text-primary"
                type="border"
                variant="border"
                >{{ $t("Cancel") }}</b-button
              >
            </router-link>
          </div>
        </form>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import $ from "jquery";

// For custom error message
import { Validator } from "vee-validate";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  components: {
    FormWizard,
    TabContent,
  },
  data() {
    return {
      setting: [],
      users: [],
      newpassword: "",
      confirm_password: "",
      url: require("@/assets/images/portrait/small/avatar-s-3.jpg"),
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
      },
    },
  },
  created() {
    this.getUsers(this.$store.getters.currentUser.id);
    this.getData();
    this.loadLocale(this.$i18n.locale);
  },

  methods: {
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     *  getData method get department data
     **/
    getData(id) {
      this.show = true;
      this.success = "";
      this.error = "";
      this.$store
        .dispatch("SettingData")
        .then((res) => {
          this.show = false;
          this.setting = res.data.data;
        })
        .catch((error) => {
          this.$log.error(
            "File : Setting.vue | Function : getDepartment() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *  submitForm method for submiting form
     **/
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.settingSubmit();
        } else {
        }
      });
    },
    /**
     *  addDepartments method for add record in a department list
     **/
    settingSubmit() {
      this.success = "";
      this.error = "";
      this.show = true;
      this.$store
        .dispatch("SettingSubmit", this.setting)
        .then((res) => {
          this.show = false;

          this.success = this.$t("SettingUpdated");
          this.$toasted.show(this.success, {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : Setting.vue | Function : settingSubmit() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     *
     *  getUsers   method  for get data login user     **/

    getUsers($id) {
      this.success = "";
      this.error = "";
      this.show = true;

      this.$store
        .dispatch("showProfile", $id)
        .then((res) => {
          this.show = false;
          this.users = res.data.data;
          if (res.data.data.profile_image) {
            this.url = res.data.data.profile_image.path;
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : Add.vue | Function : getUsers() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
#update {
  display: inline-flex;
}

#cancel {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
}

.vx-row {
  margin-top: 20px;
}
</style>    